import { useState } from 'react';
import { alerts } from '@/mocks/dashboard';
import { useTheme } from '@/hooks/useTheme';

export default function AlertsPanel() {
  const [dismissed, setDismissed] = useState<number[]>([]);
  const visible = alerts.filter((a) => !dismissed.includes(a.id));
  const { isDark } = useTheme();

  const cardBg = isDark ? '#1A1A1A' : '#fff';
  const cardBorder = isDark ? 'rgba(255,255,255,0.07)' : '#E5E5E8';
  const textMain = isDark ? '#E0E0E0' : '#1A1A1A';
  const textMuted = isDark ? '#6B6B70' : '#6B6B70';
  const separatorColor = isDark ? 'rgba(255,255,255,0.05)' : '#F5F5F7';
  const badgeBg = isDark ? 'rgba(255,255,255,0.05)' : '#F5F5F7';

  return (
    <div
      className="rounded-xl overflow-hidden"
      style={{ background: cardBg, border: `1px solid ${cardBorder}` }}
    >
      <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: `1px solid ${cardBorder}` }}>
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-semibold" style={{ color: textMain, fontFamily: 'Inter, sans-serif' }}>Сповіщення SCADA</h3>
          {visible.length > 0 && (
            <span
              className="text-[10px] font-bold px-1.5 py-0.5 rounded-full"
              style={{ background: 'rgba(184,134,11,0.15)', color: '#B8860B' }}
            >
              {visible.length}
            </span>
          )}
        </div>
        <button className="text-xs font-medium cursor-pointer whitespace-nowrap" style={{ color: textMuted, fontFamily: 'Inter, sans-serif' }}>
          Журнал →
        </button>
      </div>

      {visible.length === 0 ? (
        <div className="px-4 py-6 text-center">
          <i className="ri-checkbox-circle-line text-2xl" style={{ color: '#0D7A3C' }}></i>
          <p className="text-xs mt-1" style={{ color: textMuted, fontFamily: 'Inter, sans-serif' }}>Немає активних сповіщень</p>
        </div>
      ) : (
        <div>
          {visible.map((alert, idx) => (
            <div
              key={alert.id}
              className="flex items-start gap-0"
              style={{ borderBottom: idx < visible.length - 1 ? `1px solid ${separatorColor}` : 'none' }}
            >
              <div
                className="w-1 self-stretch shrink-0 rounded-none"
                style={{ background: alert.severity === 'warning' ? '#B8860B' : '#1F5B8F' }}
              ></div>
              <div className="flex-1 px-4 py-3">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-start gap-2">
                    <i
                      className={`text-sm mt-0.5 ${alert.severity === 'warning' ? 'ri-alert-line' : 'ri-information-line'}`}
                      style={{ color: alert.severity === 'warning' ? '#B8860B' : '#1F5B8F' }}
                    ></i>
                    <div>
                      <p className="text-xs font-semibold" style={{ color: textMain, fontFamily: 'Inter, sans-serif' }}>
                        {alert.title}
                      </p>
                      <p className="text-[11px] mt-0.5" style={{ color: textMuted, fontFamily: 'Inter, sans-serif' }}>
                        {alert.detail}
                      </p>
                      <span
                        className="inline-block mt-1 text-[9px] font-mono px-1.5 py-0.5 rounded"
                        style={{ background: badgeBg, color: textMuted, border: `1px solid ${cardBorder}` }}
                      >
                        {alert.code}
                      </span>
                    </div>
                  </div>
                  <div className="text-right shrink-0">
                    <span className="text-[10px]" style={{ color: textMuted }}>{alert.time}</span>
                    <button
                      onClick={() => setDismissed((p) => [...p, alert.id])}
                      className="block mt-1 cursor-pointer transition-opacity hover:opacity-70 whitespace-nowrap"
                    >
                      <i className="ri-close-line text-xs" style={{ color: textMuted }}></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}